{
  "generators": [
    {
      "id": "G1",
      "name": "Authority",
      "principle": "No ambient effect"
    },
    {
      "id": "G2",
      "name": "Knowledge",
      "principle": "Knowing is not permission"
    },
    {
      "id": "G3",
      "name": "Time",
      "principle": "Future evidence cannot bless the past"
    },
    {
      "id": "G4",
      "name": "Resource",
      "principle": "Authority is scarce"
    }
  ],
  "consequences": [
    {
      "code": "D1",
      "name": "DATA.ORIGIN",
      "generator": "G2",
      "mode": "IMMUNE",
      "structure": "Fibration"
    },
    {
      "code": "D2",
      "name": "DATA.REACH",
      "generator": "G2",
      "mode": "IMMUNE",
      "structure": "Opfibration"
    },
    {
      "code": "P",
      "name": "PERMIT",
      "generator": "G1",
      "mode": "IMMUNE",
      "structure": "Slice category"
    },
    {
      "code": "S",
      "name": "SEPARATE",
      "generator": "G2",
      "mode": "IMMUNE",
      "structure": "Double category"
    },
    {
      "code": "W",
      "name": "PRECOMMIT",
      "generator": "G3",
      "mode": "IMMUNE",
      "structure": "Graded monad"
    },
    {
      "code": "R1",
      "name": "RES.CONSUME",
      "generator": "G4",
      "mode": "CONTAINED",
      "structure": "Linear category"
    },
    {
      "code": "R2",
      "name": "RES.RELEASE",
      "generator": "G4",
      "mode": "CONTAINED",
      "structure": "Compact closed"
    },
    {
      "code": "C",
      "name": "COMPOSE",
      "generator": "G1",
      "mode": "INERT",
      "structure": "Operad"
    },
    {
      "code": "I1",
      "name": "INV.ESTABLISH",
      "generator": "G3",
      "mode": "INERT",
      "structure": "F-algebra"
    },
    {
      "code": "I2",
      "name": "INV.PRESERVE",
      "generator": "G3",
      "mode": "INERT",
      "structure": "F-coalgebra"
    }
  ],
  "purity": {
    "constructors": [
      {
        "name": "hor-cell",
        "lane": "horizontal",
        "meaning": "data-flow cell"
      },
      {
        "name": "ver-cell",
        "lane": "vertical",
        "meaning": "authority-flow cell"
      }
    ],
    "excludedCandidate": {
      "name": "mix-cell",
      "lane": "mixed",
      "meaning": "candidate hidden generator"
    }
  }
}
